module.exports = "/_next/static/images/avatar_Adam-449935700e6c427dcfc06adcd87bfbd0.svg";